import type {ReactElement} from 'react'
// Styles
import styles from '../client-landing-page.module.scss'
// Types
import type {BallotPageBlock} from '../../types/ballot'

interface ImageBlockProps {
  block: BallotPageBlock
}

const ImageBlock = ({block}: ImageBlockProps): ReactElement | null => {
  const imageUrl = block.formValuesObject.blockImage
  const imageAltText = block.formValuesObject.blockTitle || 'Landing page image'

  if (!imageUrl) return null

  return (
    <img
      src={imageUrl}
      alt={imageAltText}
      className={styles['__cover-image']}
    />
  )
}

export default ImageBlock
